export function safeUrl(value) {
  if (typeof value !== "string" || value.trim() === "") return null;

  const url = value.trim();
  if (url.startsWith("/") || url.startsWith("#")) return url;

  try {
    const parsed = new URL(url);
    return ["https:", "mailto:"].includes(parsed.protocol) ? url : null;
  } catch {
    return null;
  }
}

export function chooseMediaUrl({ src, poster, failed }) {
  if (!failed) {
    const primary = safeUrl(src);
    if (primary) return primary;
  }
  return safeUrl(poster);
}
